import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Col, Row, Modal } from "antd";
import {
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import "./index.css";
import { useHistory } from "react-router";
import moment from "moment";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import { ToastContainer } from "react-toastify";
import { ToWords } from "to-words";

const ActivityVouchers = (props) => {
  const history = useHistory();

  const toWords = new ToWords();
  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoMobile = !isEmpty(userNameDetails)
    ? userNameDetails.user.mobileNo
    : "";

  //Props values from parties home
  const activityData =
    props.location && props.location.state
      ? props.location.state.data.transactionDetails
      : "";

  const [pageRouting, setPageRouting] = useState(false);

  //Calculate totals
  const calculateTotals = (rows) => {
    let quantityCount = 0;

    rows.forEach((row) => {
      quantityCount += parseFloat(row.qty) || 0;
    });

    return { quantityCount };
  };

  const [totals, setTotals] = React.useState({
    quantityCount: 0,
  });

  useEffect(() => {
    if (!isEmpty(activityData) && activityData.items.length > 0) {
      const total = calculateTotals(activityData.items);
      setTotals(total);
    }
  }, [activityData]);
  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Purchase | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <Row>
            <Col span={24}>
              <Row>
                <Col
                  span={24}
                  className="bg-[#ffffff] border-b-1 border border-x-0 border-t-0"
                >
                  <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
                    <div className="flex">
                      <ArrowLeftOutlined
                        onClick={() => setPageRouting(true)}
                        className="font-bold text-[18px]"
                      />
                      <h1 className="text-[20px] mb-2 ml-2 font-semibold">
                        {"Voucher"}
                      </h1>
                    </div>
                  </div>
                </Col>

                <Col span={24}>
                  <Row className="border border-b-1 border-t-0 border-x-0 flex mt-3 mb-3">
                    <Col span={20} className="mb-4 pb-6">
                      <div
                        className={
                          "rounded-md pb-3 pl-8 pr-8 mb-3 add-vouchers-statment-main"
                        }
                      >
                        <Row>
                          <Col span={24} className="pb-3 pt-3 ml-4">
                            <h1 className="text-[14px] font-semibold uppercase mt-2 party-label">
                              {activityData ? activityData.transActionType : ""}
                            </h1>
                          </Col>
                        </Row>
                        <Row
                          className="flex justify-center ml-4 mr-4"
                          style={{
                            border: "1px solid black",
                          }}
                        >
                          <Col
                            md={24}
                            className={
                              "pt-4 pb-4 border-solid rounded-sm bg-[#ffffff]"
                            }
                          >
                            <Row id="pdf-content">
                              <Col span={24} className="pb-3 pt-3">
                                <div className="w-[100%]">
                                  <p className="party-label flex justify-center">
                                    <p className="text-[13px] font-semibold mr-2">
                                      Mobile:
                                    </p>
                                    <p className="text-[13px]">
                                      {userInfoMobile}
                                    </p>
                                  </p>
                                </div>
                              </Col>
                              <Col
                                span={24}
                                style={{
                                  border: "1px solid black",
                                  borderLeft: "none",
                                  borderRight: "none",
                                }}
                              >
                                <Row>
                                  <Col
                                    md={10}
                                    sm={24}
                                    lg={10}
                                    xs={24}
                                    style={{
                                      borderRight: "1px solid black",
                                    }}
                                  >
                                    <div className="p-2 pt-3 pb-3">
                                      <h1 className="purchase-label text-[12px] mr-3 uppercase">
                                        Bill From
                                      </h1>
                                      <p className="mt-1  text-[14px]  purchase-label font-semibold">
                                        {activityData
                                          ? activityData.vendorName
                                          : ""}
                                      </p>
                                      <p className="mt-1  text-[12px]  purchase-label">
                                        Address:{" "}
                                        {activityData
                                          ? activityData.vendorName
                                          : ""}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col md={14} sm={24} lg={14} xs={24}>
                                    <Row className="w-[100%] flex justify-between pl-8 pr-5 pt-5 pb-5">
                                      <div className="w-[33%]">
                                        <h1 className="purchase-label text-[12px] font-semibold mr-3">
                                          PO No:
                                        </h1>
                                        <p className="mt-[-2px]">
                                          {activityData ? activityData.poNo : 1}
                                        </p>
                                      </div>
                                      <div className="w-[33%]">
                                        <h1 className="purchase-label text-[12px] font-semibold mr-3">
                                          PO Date:
                                        </h1>
                                        <p className="mt-[-2px]">
                                          {activityData
                                            ? moment(
                                                activityData.poDate
                                              ).format("DD/MM/YYYY")
                                            : ""}
                                        </p>
                                      </div>
                                      <div className="w-[33%]">
                                        <h1 className="purchase-label text-[12px] font-semibold mr-3">
                                          Expiry Date:
                                        </h1>
                                        <p className="mt-[-2px]">
                                          {activityData
                                            ? moment(
                                                activityData.povalidDate
                                              ).format("DD/MM/YYYY")
                                            : ""}
                                        </p>
                                      </div>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                              {/* PO statement */}
                              <Col span={24} className="add-create-item-table">
                                <table className="mb-6 table-purchase-serial table-responsive">
                                  <thead>
                                    <tr className="table-activities-head-main">
                                      <th className="uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        S.No
                                      </th>
                                      <th className="uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Items
                                      </th>
                                      <th className="uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Qty
                                      </th>
                                      <th className="uppercase table-activities-purchase-head text-[12px] font-semibold">
                                        Rate
                                      </th>
                                      <th className="uppercase text-end table-activities-purchase-head text-[12px] font-semibold">
                                        Amount
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="mb-10">
                                    {activityData &&
                                    activityData.items &&
                                    activityData.items.length > 0
                                      ? activityData.items.map(
                                          (data, index) => {
                                            return (
                                              <tr
                                                key={index}
                                                className={
                                                  "table-purchase-row border border-b-1 border-x-0 border-t-0"
                                                }
                                              >
                                                <td className="table-activities-purchase-data p-1">
                                                  {index + 1}
                                                </td>
                                                <td className="table-activities-purchase-data p-1">
                                                  {data.itemName}
                                                </td>
                                                <td className="table-activities-purchase-data p-1 text-end">
                                                  {data.qty
                                                    ? data.qty + " PCS"
                                                    : 0 + " PCS"}
                                                </td>

                                                <td className="table-activities-purchase-data p-1 text-end">
                                                  {data.totalamount}
                                                </td>
                                                <td className="table-activities-purchase-data p-1 text-end">
                                                  {data.totalamount}
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )
                                      : ""}
                                  </tbody>
                                </table>
                                <table className="mt-[200px] w-[100%]">
                                  <tbody className="w-[100%]">
                                    <tr
                                      style={{
                                        borderTop: "1px solid black",
                                        borderBottom: "1px solid black",
                                        backgroundColor: "#e7e7e7",
                                      }}
                                      className="font-semibold "
                                    >
                                      <td
                                        className="w-[17%] uppercase table-activities-purchase-head p-2 font-semibold text-[14px]"
                                        // colSpan={2}
                                      >
                                        {""}
                                      </td>
                                      <td
                                        className="w-[20%] table-activities-purchase-head uppercase p-2 font-semibold text-[14px]"
                                        // colSpan={2}
                                      >
                                        {"SubTotal"}
                                      </td>

                                      <td className="w-[17%] table-activities-purchase-total-head p-2 text-end">
                                        <p className="">
                                          {totals.quantityCount}
                                        </p>
                                      </td>
                                      <td className="w-[17%] table-activities-purchase-head p-2">
                                        {""}
                                      </td>
                                      <td className="w-[26%] table-activities-purchase-total-head p-2 text-end">
                                        <p className="">
                                          {activityData &&
                                          activityData.subtotalamount
                                            ? "₹ " + activityData.subtotalamount
                                            : "₹ " + 0}
                                        </p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <Row className="">
                                  <Col
                                    md={24}
                                    style={{
                                      borderBottom: "1px solid black",
                                      padding: "10px",
                                    }}
                                  >
                                    <div className="purchase-label">
                                      <h1 className="font-semibold text-start text-[14px]">
                                        Total Amount (in words)
                                      </h1>
                                      <h1 className="mt-1 font-medium text-[12px] text-start">
                                        {activityData && activityData.NetAmount
                                          ? toWords.convert(
                                              activityData.NetAmount,
                                              {
                                                currency: true,
                                                ignoreDecimal: true,
                                              }
                                            )
                                          : ""}
                                      </h1>
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={24} className="p-2">
                                    <div className="purchase-label">
                                      <h1 className="font-semibold text-[14px]">
                                        Terms and Conditions
                                      </h1>
                                      <p className="text-[12px]">
                                        {activityData
                                          ? activityData.termsandconditions
                                          : ""}
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            {/* Parties input section with bulk actions */}
          </Row>
        </Col>
      </Row>

      <Modal
        open={pageRouting}
        onOk={() => {
          setPageRouting(false);
          history.push("/settings/manage-users");
        }}
        closeIcon
        maskClosable={false}
        rootClassName="p-15 h-[300px]"
        okText={"Yes, Leave"}
        cancelText={"No, Stay"}
        onCancel={() => setPageRouting(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <div className="mr-3">
              <OkBtn />
            </div>
            <CancelBtn />
          </div>
        )}
        width={500}
      >
        <div className="text-center w-[100%]">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to leave this page?
          </h1>
          <p className="text-center text-[14px] mt-2">
            All unsaved changes will be lost!
          </p>
        </div>
      </Modal>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="colored"
      />
    </React.Fragment>
  );
};

ActivityVouchers.propTypes = {
  location: PropTypes.any,
};

export default ActivityVouchers;
